import ToolbarLink from "./ToolbarLink";
import { ComponentPropsWithoutRef, FC } from "react";

const Toolbar: FC<{ links: ComponentPropsWithoutRef<typeof ToolbarLink>[] }> = (props) => {
  return (
    <div className="toolbar tabbar tabbar-labels" style={{ position: "fixed" }}>
      <div className="toolbar-inner">
        {props.links.map((link) => (
          <ToolbarLink key={link.label} {...link} />
        ))}
      </div>
    </div>
  );
};

export default Toolbar;
